import { isEqual } from "lodash";

import ability, { defineAbilityFor } from "@/services/ability";

// Create our own vuex plugin that watches for user permission changes and
// updates CASL rules accordingly
export const caslPlugin = store => {
	store.watch(
		(state, getters) => getters["auth/user"],
		(newUser, oldUser) => {
			// Do a deep comparison
			if (!isEqual(newUser, oldUser)) {
				window.vm.$log("User permissions changed. Updating abilities.");

				// Update app ability instance with new rules
				const newAbility = defineAbilityFor(newUser);
				ability.update(newAbility.rules);
			}
		}
	);
};
